import { render, staticRenderFns } from "./shuttleManage.vue?vue&type=template&id=ff2e29ea&scoped=true&"
import script from "./shuttleManage.vue?vue&type=script&lang=js&"
export * from "./shuttleManage.vue?vue&type=script&lang=js&"
import style0 from "./shuttleManage.vue?vue&type=style&index=0&id=ff2e29ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2e29ea",
  null
  
)

export default component.exports